"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Created by andi on 08.09.16.
 */
var OAuth = /*#__PURE__*/function () {
  function OAuth() {
    _classCallCheck(this, OAuth);

    var ENVIRON = typeof ENV !== 'undefined' ? ENV : {
      auth: {}
    };
    this.tokenName = 'accessToken';
    this.client_id = ENVIRON.auth.client_id || 'client_id';
    this.response_type = ENVIRON.auth.response_type || 'token';
    this.redirect_uri = ENVIRON.auth.redirect_uri || 'http://redirect.url';
    this.authorize_uri = ENVIRON.auth.authorize_url || 'http://authorize.url';
    this.revoke_uri = ENVIRON.auth.revoke_uri || 'http://revoke.url';
  }

  _createClass(OAuth, [{
    key: "getAuthorizeUrl",
    value: function getAuthorizeUrl() {
      return "".concat(this.authorize_uri, "?response_type=").concat(this.response_type, "&client_id=").concat(this.client_id, "&redirect_uri=").concat(encodeURIComponent("".concat(this.redirect_uri, "?tt=").concat(new Date().getTime())));
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(token) {
      localStorage.setItem(this.tokenName, token);
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return localStorage.getItem(this.tokenName);
    }
  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      return !!this.getAccessToken();
    }
  }, {
    key: "getRevokeUrl",
    value: function getRevokeUrl() {
      return "".concat(this.revoke_uri, "?token=").concat(encodeURIComponent(this.getAccessToken()));
    }
  }, {
    key: "removeAccessToken",
    value: function removeAccessToken() {
      localStorage.removeItem(this.tokenName);
    }
  }]);

  return OAuth;
}();

var _default = new OAuth();

exports["default"] = _default;